import { render, staticRenderFns } from "./WorkspacePanel.vue?vue&type=template&id=0fc48cbf"
import script from "./WorkspacePanel.vue?vue&type=script&lang=js"
export * from "./WorkspacePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports